import { render, staticRenderFns } from "./teacher-list.vue?vue&type=template&id=6d774bf2&scoped=true"
import script from "./teacher-list.vue?vue&type=script&lang=js"
export * from "./teacher-list.vue?vue&type=script&lang=js"
import style0 from "./teacher-list.vue?vue&type=style&index=0&id=6d774bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d774bf2",
  null
  
)

export default component.exports